import React, { useState } from 'react';
import Icon from '../../../icons/components/Icon';
import Popover from '../../../popover/components/Popover.web';
import { Popover as MuiPopover } from '@mui/material';
/**
 * Displays the `ToolboxButtonWithIcon` component.
 *
 * @param {Object} props - Component's props.
 * @returns {ReactElement}
 */
export default function ToolboxButtonWithPopup(props) {
    const { ariaLabel, children, icon, iconDisabled, onPopoverClose, onPopoverOpen, popoverContent, styles, trigger, visible, mode } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    if (!icon) {
        return (React.createElement("div", { className: 'settings-button-container', style: styles },
            React.createElement(Popover, { content: popoverContent, headingLabel: ariaLabel, onPopoverClose: onPopoverClose, onPopoverOpen: onPopoverOpen, position: 'top', trigger: trigger, visible: visible }, children)));
    }
    if (mode === 'mui') {
        return (React.createElement("div", { className: 'settings-button-container', style: styles },
            children,
            React.createElement("div", { className: `settings-button-small-icon ${iconDisabled
                    ? 'settings-button-small-icon--disabled'
                    : ''}` },
                React.createElement(Icon, { alt: ariaLabel, 
                    // className = { `settings-button-small-icon ${iconDisabled
                    //     ? 'settings-button-small-icon--disabled'
                    //     : ''}` }
                    size: 16, src: icon, onClick: (e) => setAnchorEl(e.currentTarget) }),
                React.createElement(MuiPopover, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: () => setAnchorEl(null), anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    }, transformOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }, sx: [
                        {
                            '& .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded': {
                                backgroundColor: 'transparent'
                            }
                        },
                        {
                            '& .maxheight-custom': {
                                margin: 0
                            }
                        }
                    ] }, popoverContent))));
    }
    return (React.createElement("div", { className: 'settings-button-container', style: styles },
        children,
        React.createElement("div", { className: `settings-button-small-icon ${iconDisabled
                ? 'settings-button-small-icon--disabled'
                : ''}` },
            React.createElement(Popover, { content: popoverContent, headingLabel: ariaLabel, onPopoverClose: onPopoverClose, onPopoverOpen: onPopoverOpen, position: 'top', visible: visible },
                React.createElement(Icon, { alt: ariaLabel, 
                    // className = { `settings-button-small-icon ${iconDisabled
                    //     ? 'settings-button-small-icon--disabled'
                    //     : ''}` }
                    size: 16, src: icon })))));
}
